export default __webpack_public_path__ + "static/Danone_reciclare_1920x1080-daf3667bcc1579e297de832862a8a188.jpg";